// https://app.growthbook.io/features/mccerts-3381_v1
export const MCCERTS_3381_UBER_CLP_HERO_COPY_FLAG = 'mccerts-3381_v1'
